// extracted by mini-css-extract-plugin
export default {"fa-spinner":"Attachments_fa-spinner__48sKI","spinner":"Attachments_spinner__r5Ln1"};